// src/pages/Finance/OverduePayments/Overdue/GeneratePaymentReminderButton.jsx
import React from "react"
import { Button, Tooltip, message, Modal } from "antd"
import { SendOutlined } from "@ant-design/icons"
import { getFunctions, httpsCallable } from "firebase/functions"

export default function GeneratePaymentReminderButton({
  selectedInvoices = [],
  manufacturer,
  email,
  disabled,
  disableReason,
}) {
  const [loading, setLoading] = React.useState(false)

  const handleClick = () => {
    if (!email?.trim()) {
      message.warning("Enter an email address first.")
      return
    }

    const clientName = selectedInvoices[0]?.client?.client || "this client"

    Modal.confirm({
      title: "Send payment reminder?",
      content: (
        <div>
          <p style={{ marginBottom: 4 }}>PDF will be generated and sent to:</p>
          <div style={{ fontWeight: 600 }}>{email}</div>
          <p style={{ marginTop: 8, color: "#888", fontSize: 12 }}>
            {selectedInvoices.length} invoice(s) for {clientName}
          </p>
        </div>
      ),
      okText: "Send",
      onOk: () => executeSend(),
    })
  }

  const executeSend = async () => {
    setLoading(true)
    try {
      const fns = getFunctions()
      const call = httpsCallable(fns, "sendPaymentReminder")

      const { data } = await call({
        invoices: selectedInvoices,
        manufacturer,
        clientId: selectedInvoices[0]?.clientId,
        overrideEmail: email.trim(),
      })

      message.success(`Reminder sent to ${data.sentTo?.join(", ")}`)
    } catch (err) {
      console.error("Send failed:", err)
      message.error(err?.message || "Failed to send reminder.")
    } finally {
      setLoading(false)
    }
  }

  const btn = (
    <Button
      type="primary"
      icon={<SendOutlined />}
      loading={loading}
      disabled={disabled || loading || !email?.trim()}
      onClick={handleClick}>
      Generate Payment Reminder
    </Button>
  )

  return disableReason && disabled ? <Tooltip title={disableReason}>{btn}</Tooltip> : btn
}
